import { Component, effect, input, output, signal } from '@angular/core';
import { ProductStatus } from '@mira-avant/mtlibs';
import { ProductStatusService } from '../../../../services/product-status';
import { Subscription } from 'rxjs/internal/Subscription';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-product-status-select',
	standalone: true,
	imports: [NzSelectModule, FormsModule],
	templateUrl: './product-status-select.html',
	styleUrl: './product-status-select.scss',
})
export class ProductStatusSelect {
	uuid = input<string | undefined>();
	productName = input<string | undefined>();
	onChange = output<ProductStatus | undefined>();
	productStatuses = signal<ProductStatus[]>([]);
	selectedUuid: string | undefined = undefined;
	private sub: Subscription | undefined;

	constructor(private productStatusService: ProductStatusService) {
		effect(() => {
			const uuid = this.uuid();
			const productName = this.productName();

			this.refresh();
		});

		this.sub = this.productStatusService.productStatus$.subscribe(() => this.refresh());
	}

	private refresh() {
		const uuid = this.uuid();
		const productName = this.productName();

		this.selectedUuid = uuid;

		const productStatuses = productName ? this.productStatusService.getByProductName(productName) : [];

		this.productStatuses.set(productStatuses || []);
	}

	public onSelectionChanged(uuid: string): void {
		const productStatus = this.productStatuses().find(ps => ps.uuid === uuid);
		this.onChange.emit(productStatus);
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
